/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Rahul Bagaria <Rahul@wakencode.com>, 6 2023
 *
 */

/**
 * @description This file contains all the routes constants for the application
 */

export const ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  MY_ACCOUNT: "/myaccount",
  JOBS: "/jobs",
  WORK_ORDERS: "/workorders",
  ABOUT_US: "/about_us",
};

/**
 * @description This is a enum for all the routes in the application
 */
export enum RoutesEnum {
  DASHBOARD = "Dashboard",
  JOBS = "Jobs",
  WORK_ORDERS = "Work Orders",
  ABOUT = "About Us",
}
